import React from 'react';
import { Modal as RSModal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import logo from '../../../../assets/imgs/nokia-logo.svg';

function Modal({ toggle, isOpen, children, ...props }: any) {
    return (
        <RSModal className="login-modal" isOpen={isOpen} toggle={toggle} {...props}>
            <ModalHeader toggle={toggle}>
                <img width="150" height="35" src={logo} alt="logo zina bi" />
            </ModalHeader>
            {children}
        </RSModal>
    );
}

export { Modal, ModalBody, ModalFooter, ModalHeader };
